let _ = require('ES/lib/lodash');
let dd = require('ES/lib/dd');
let radio = require('ES/lib/radio');
let esUtils = require('ES/utils/esUtils');
let Constants = require("../../../utils/Constants");
let SortableTable = require("ES/widgets/SortableTable");
let AuthedUserSession = require("../../../utils/AuthedUserSession");

let DashArea = dd.createClass({
  render() {
    let {title, children, iconClassName, className} = this.props;
    return dd.div({className: "panel panel-default " + (className ? ' ' + className : '')},
      dd.div({className: "panel-heading"},
        dd.i({className: "fa fa-fw" + (iconClassName ? ' ' + iconClassName : '')}),
        ' ' + title
      ),
      dd.div({className: "panel-body"},
        children
      )
    );
  }
});

let PipelineNumber = dd.createClass({
  __searchFor(searchterm, filter_to_sid) {
    //the detail link has been clicked
    return esUtils.wrapPreventDefault(function () {
      let q = {
        searchterm: searchterm,
        exclude_event_types: [Constants.EVENT_STATUSES.zimbra, Constants.EVENT_STATUSES.canceled]
      };
      if (filter_to_sid > 0) {
        q.sids = [filter_to_sid];
      }
      radio('EventSearchAside_search').broadcast(q);
    });
  },
  render() {
    let {filter_to_sid} = this.props;
    let can_view_fees = AuthedUserSession.doIHaveAccess.view_fees.any(
      filter_to_sid > 0 ? filter_to_sid : AuthedUserSession.all_sids_i_have_permissions_for
    );
    return dd.div({className: "panel panel-" + (this.props.className || '')},
      dd.div({className: "panel-heading"},
        dd.div({className: "row"},
          dd.div({className: "col-xs-3 visible-lg "},
            dd.i({className: "fa fa-circle-o fa-4x"})
          ),
          dd.div({className: "col-xs-9 text-right"},
            dd.div({className: "huge"}, esUtils.format_number(this.props.qty, 0)),
            dd.div(null, this.props.label)
          )
        )
      ),
      dd.a({href: "#", onClick: this.__searchFor(this.props.searchfor, filter_to_sid)},
        dd.div({className: "panel-footer"},
          can_view_fees ? dd.span({className: "pull-left detaillink"}, esUtils.format_currency(this.props.value, 0) + '') : null,
          dd.span({className: "pull-right"},
            dd.i({className: "fa fa-arrow-circle-right"})
          ),
          dd.div({className: "clearfix"})
        )
      )
    );
  }
});

module.exports = dd.createClass({
  __eventClicked(eid, tab) {
    return esUtils.wrapPreventDefault(function () {
      radio('Hashbang_set').broadcast('/events/' + eid + (tab ? '/' + tab : ''));
    });
  },
  render() {
    let self = this;
    let {filter_to_sid, Displaylists} = this.props;
    let dashboardData = this.props.Dashboarddata || {};
    let pipeline = _.isPlainObject(dashboardData.pipeline) ? dashboardData.pipeline['sid' + (filter_to_sid > 0 ? filter_to_sid : 0)] : null;

    let preferences = (Displaylists && Displaylists.user && Displaylists.user.myevents_preferences) || {};
    let today = new Date();
    let is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any(AuthedUserSession.all_sids_i_have_permissions_for);

    let isRowForSelectedSID = function (row) {
      if (!row.hasOwnProperty('sids')) {
      	return false;
      }
      if (preferences.hide_personal_days_on_dashboard_lists && row.hasOwnProperty('psnl') && row.psnl) {
        return false;//filter out personal items
      }
      return (filter_to_sid < 1) || _.includes(row.sids, filter_to_sid);
    };

    let tip = Displaylists && Displaylists.tip || {};

    return dd.div({className: 'Dashboard container-fluid'},
      pipeline ? DashArea({title: 'Events Pipeline', iconClassName: 'fa-usd'},
        dd.div({className: "panel-body"},
          dd.div({className: "row"},
            dd.div({className: 'col-xs-4'},
              PipelineNumber({className: 'confirmed', qty: pipeline.s1.qty, label: 'confirmed', value: pipeline.s1.val, searchfor: 'pipeline:confirmed', filter_to_sid})
            ),
            dd.div({className: 'col-xs-4'},
              PipelineNumber({className: 'held', qty: pipeline.s0.qty, label: 'held', value: pipeline.s0.val, searchfor: 'pipeline:held', filter_to_sid})
            ),
            dd.div({className: 'col-xs-4'},
              PipelineNumber({className: 'lead', qty: pipeline.s10.qty, label: 'leads', value: pipeline.s10.val, searchfor: 'pipeline:lead', filter_to_sid})
            )
          )
        )
      ) : null,

      (!AuthedUserSession.is_st_family) && tip && _.isString(tip.tiptext) ? DashArea({title: 'Tip of the day', iconClassName: 'fa-lightbulb-o'},
        dd.div({className: 'row'},
          dd.div({className: 'col-sm-3 text-center text-muted'},
            dd.i({
              className: tip.priority >= 8 ? 'fa fa-warning text-danger' : 'fa fa-lightbulb-o',
              style: {fontSize: 100}
            })
          ),
          dd.div({className: 'col-sm-9'},
            dd.p({className: "preserve-whitespace"}, tip.tiptext.trim()),
            tip.link ? dd.p(null,
              dd.a({href: tip.link, target: '_blank'}, tip.linktext || tip.link)
            ) : null
          )
        )
      ) : null,

      (!is_limited_speaker) ? DashArea({title: 'Action List', iconClassName: 'fa-check-circle-o'},
        SortableTable({
          default_sort: {
            sort_col: 0,
            sort_ascending: true
          }, table: {
            header: [
              {body: 'due', className: 'date'},
              {body: 'action'},
              {body: 'organization', className: 'organization'}
            ],
            rows: _.map(_.filter(dashboardData.actionlist, isRowForSelectedSID), function (row) {
              let date = esUtils.convertFromISO8601(row.date);
              return {
                props: {'className': ((today.getTime() >= date.getTime()) ? 'danger' : ''), onClick: self.__eventClicked(row.eid, 'action_list'), 'data-eid': row.eid},
                cols: [
                  {body: esUtils.format_date(date, esUtils.format_date.masks.mediumDate), sortkey: date},
                  {body: row.dsc},
                  {
                    sortkey: row.org, render: function () {
                      let intitials = filter_to_sid < 1 ? dd.span({className: 'initials'}, row.intls) : null;
                      return dd.span(null, intitials, row.org);
                    }
                  }
                ]
              };
            })
          }
        })
      ) : null,
      DashArea({title: 'Recent Activity', iconClassName: 'fa-bars', className: 'recentactivity'},
        SortableTable({
          default_sort: {
            sort_col: 0,
            sort_ascending: preferences.sort_results !== 'earliest_at_bottom'
          }, table: {
            header: [
              {body: 'changed', className: 'date'},
              {body: 'status', className: 'status'},
              {body: 'organization', className: 'organization'}
            ],
            rows: _.map(_.filter(dashboardData.activity, isRowForSelectedSID), function (row) {
              let date = esUtils.convertFromISO8601(row.date);
              return {
                props: {onClick: self.__eventClicked(row.eid, 'details'), 'data-eid': row.eid},
                cols: [
                  {body: esUtils.format_date(date, esUtils.format_date.masks.mediumDate), sortkey: date},
                  {body: row.st},
                  {
                    sortkey: row.dsc, render: function () {
                      let intitials = filter_to_sid < 1 ? dd.span({className: 'initials'}, row.intls) : null;
                      return dd.span(null, intitials, row.dsc);
                    }
                  }
                ]
              };
            })
          }
        })
      ),
      DashArea({title: 'Upcoming confirmed', iconClassName: 'fa-calendar'},
        SortableTable({
          default_sort: {
            sort_col: 0,
            sort_ascending: preferences.sort_results !== 'earliest_at_bottom'
          }, table: {
            header: [
              {body: 'date', className: 'date'},
              {body: 'organization', className: 'organization'},
              {body: 'venue'}
            ],
            rows: _.map(_.filter(dashboardData.upcoming, isRowForSelectedSID), function (row) {
              let date = esUtils.convertFromISO8601(row.date);
              return {
                props: {onClick: self.__eventClicked(row.eid, 'details'), 'data-eid': row.eid},
                cols: [
                  {body: esUtils.format_date(date, esUtils.format_date.masks.mediumDate), sortkey: date},
                  {
                    sortkey: row.dsc, render: function () {
                      let intitials = filter_to_sid < 1 ? dd.span({className: 'initials'}, row.intls) : null;
                      return dd.span(null, intitials, row.dsc);
                    }
                  },
                  {body: row.vnu}
                ]
              };
            })
          }
        })
      )
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/Dashboard.js